<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="this.generateStatusObj(this.selectedResourcesItem).color">
          {{this.generateStatusObj(this.selectedResourcesItem).icon}}
        </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card color="wplgrey0">
          <v-card-title :class="ui.textTitle">
            {{defineIDGShortLastSix(selectedResourcesItem.basic.idi)}} Resource
            <v-spacer/>
            {{displayDocumentIDGTypeA(this.selectedResourcesItem.basic.tag, this.selectedResourcesItem.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2">
                  People Resource Info
                </div>
                <v-spacer/>
                <div class="mr-4">
                  {{selectedResourcesItem.char.status}}
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="selectedResourcesItem.basic.title"
                  hint="trade name"
                  prepend-icon="title"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedResourcesItem.char.type"
                  hint="type"
                  prepend-icon="grid_view"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedResourcesItem.basic.id"
                  hint="trade id"
                  prepend-icon="fingerprint"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedResourcesItem.char.dis"
                  hint="discipline"
                  prepend-icon="engineering"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedResourcesItem.char.per"
                  prepend-icon="person"
                  hint="person"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedResourcesItem.char.hrs"
                  hint="hours"
                  prepend-icon="schedule"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedResourcesItem.char.rate"
                  prepend-icon="straighten"
                  hint="rate"
                  suffix="$/hr"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-spacer/>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor"
                v-if="selectedResourcesItem.char.oid !== ''">
                  <v-icon left :color="ui.btnColor"> shopping_bag </v-icon>
                    <div :class="ui.textSubheadingBold">
                    {{selectedResourcesItem.char.oid}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> person_add </v-icon>
                    <div :class="ui.textSubheadingBold">
                    {{this.calcResourcePersonHours(this.selectedResourcesItem.char)}}
                  </div>
                </v-chip>
                <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                  <v-icon left :color="ui.btnColor"> paid </v-icon>
                    <div :class="ui.textSubheadingBold">
                    {{this.calcResourceCost(this.selectedResourcesItem.char)}}
                  </div>
                </v-chip>
              </v-layout>
            </v-container>
            <v-layout row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import master from "@/data/forms/mixins/master.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import statusFunctions from "@/data/functions/mixins/statusFunctions.js";
export default {
  // eslint-disable-next-line
  mixins: [
    master,
    dateFunctions,
    apptheme,
    numberFunctions,
    financeFunctions,
    displayFunctions,
    statusFunctions
  ],
  // components: {
  //   TaskItemSummaryBar
  // },
  components: {
    // InfoDateAgoName
  },
  computed: {
    ...mapGetters(["getResourcesList", "getCurrentPage"]),
    // selected task item
    selectedResourcesItem() {
      return this.resources;
    }
  },
  props: {
    resources: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
